import { render, staticRenderFns } from "./Aprendizaje.vue?vue&type=template&id=36a675be&"
import script from "./Aprendizaje.vue?vue&type=script&lang=js&"
export * from "./Aprendizaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports